/**
 * Reset Mobile Menu - Resets mobile menu to top level when drawer is closed
 */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Watch for the slideout close event
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          const slideoutMenu = document.querySelector("#theme-menu");
          if (
            slideoutMenu &&
            slideoutMenu.classList.contains("slideout-panel-hidden")
          ) {
            // The mobile drawer was closed
            // Reset mobile menu to top level
            document.querySelectorAll(".mobile-menu").forEach((menu) => {
              menu.classList.remove("active");
            });
            document
              .querySelectorAll(".mobile-menu-child, .mobile-menu-grandchild")
              .forEach((menu) => {
                menu.classList.add("mobile-menu-hidden");
              });
            document.querySelector(".mobile-menu-main").classList.add("active");
            document
              .querySelectorAll(".mobile-menu-link.mobile-menu-sub")
              .forEach((link) => {
                link.setAttribute("aria-expanded", "false");
              });
          }
        }
      });
    });

    // Start observing the mobile menu drawer
    const slideoutMenu = document.querySelector("#theme-menu");
    if (slideoutMenu) {
      observer.observe(slideoutMenu, { attributes: true });
    }

    // Alternative approach: hook into the close button click
    const closeButtons = document.querySelectorAll(".mobile-menu-close");
    closeButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // Wait a bit for the slideout close animation to finish
        setTimeout(() => {
          document.querySelectorAll(".mobile-menu").forEach((menu) => {
            menu.classList.remove("active");
          });
          document
            .querySelectorAll(".mobile-menu-child, .mobile-menu-grandchild")
            .forEach((menu) => {
              menu.classList.add("mobile-menu-hidden");
            });
          document.querySelector(".mobile-menu-main").classList.add("active");
          document
            .querySelectorAll(".mobile-menu-link.mobile-menu-sub")
            .forEach((link) => {
              link.setAttribute("aria-expanded", "false");
            });
        }, 300);
      });
    });
  });
})();
